import { render, staticRenderFns } from "./NormalSearchNav296.vue?vue&type=template&id=fc855048&scoped=true"
import script from "./NormalSearchNav296.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav296.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc855048",
  null
  
)

export default component.exports